module.exports = __webpack_public_path__ + "img/x22.5c9e7000.jpg";